/**
 * Accessorial Type enum
 *
 * Defines all types of accessorials that can be charged.
 */

export const AccessorialType = {
  /** Charge for idle driver time */
  DELAY: {
    value: 'delay',
    name: 'Delay',
    code: 'delay',
    desc: 'Charge incurred for an idle driver based on time spent.',
  },
  /** Charge for vehicle refueling */
  FUEL: {
    value: 'fuel',
    name: 'Fuel',
    code: 'fuel',
    desc: 'Charge to cover the cost of refueling the vehicle.',
  },
  /** Charge for out-of-region insurance */
  INSURANCE: {
    value: 'insurance',
    name: 'Insurance',
    code: 'insurance',
    desc: 'Charge incurred when out of region insurance is used.',
  },
  /** Charge for partially completed move */
  PARTIAL: {
    value: 'partial',
    name: 'Partial',
    code: 'partial',
    desc: 'Charge for a partially completed move.',
  },
  /** Charge for rideshare to transport stranded driver */
  RIDE: {
    value: 'ride',
    name: 'Ride',
    code: 'ride',
    desc: 'Charge to cover the cost of a ride for a stranded driver.',
  },
  /** Charge for roadside assistance */
  ROADSIDE: {
    value: 'roadside',
    name: 'Roadside',
    code: 'roadside',
    desc: 'Charge to cover the cost of roadside assistance for the vehicle.',
  },
  /** Charge for toll roads */
  TOLL: {
    value: 'toll',
    name: 'Toll',
    code: 'toll',
    desc: 'Charge to cover the cost of a toll during the move.',
  },
  /** Charge for towing the vehicle */
  TOW: {
    value: 'tow',
    name: 'Tow',
    code: 'tow',
    desc: 'Charge to cover the cost of towing the vehicle.',
  },
  /** Flag to waive all move charges */
  WAIVED: {
    value: 'waived',
    name: 'Waived',
    code: 'waived',
    desc: 'Flag to waive all move charges.',
  },
  /** Driver expense reimbursement */
  REIMBURSEMENT: {
    value: 'reimbursement',
    name: 'Reimbursement',
    code: 'reimbursement',
    desc: 'Reimbursement for a driver expense.',
  },
  /** Rideshare surge pricing */
  SURGE: {
    value: 'surge',
    name: 'Surge',
    code: 'surge',
    desc: 'Charge to cover the cost of a surge during the move.',
  },
} as const

export type AccessorialTypeCode = typeof AccessorialType[keyof typeof AccessorialType]['code']

/** Get all valid accessorial type codes */
export function getValidTypeCodes(): AccessorialTypeCode[] {
  return Object.values(AccessorialType).map((type) => type.code)
}
